import {
  MOUNT,
  ON_INPUT_CHANGE,
  ON_ENTER,
  ON_SKU_CHANGE,
  CLEAR_SKU,
  CLEAR_SEARCH,
  CLEAR_TABLE_FILTER,
  CLEAR_TABLE_SORT,
  UPDATE_SKU,
  UPDATE_REPORT_DURATION,
  UPDATE_SEARCH,
  UPDATE_TABLE_FILTER,
  UPDATE_TABLE_SORT,
  FETCH_PRODUCT_SKUS,
  FETCH_PRODUCT_SKUS_START,
  FETCH_PRODUCT_SKUS_SUCCESS,
  FETCH_PRODUCT_SKUS_ERROR,
  FETCH_WEEKLYSTATUS_REPORT,
  FETCH_WEEKLYSTATUS_REPORT_START,
  FETCH_WEEKLYSTATUS_REPORT_SUCCESS,
  FETCH_WEEKLYSTATUS_REPORT_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const mount = ({ sku, week, year,tableFilter, tableSort }) => ({ type: MOUNT, sku,week, year, tableFilter, tableSort })

const onInputChange = (value) => ({ type: ON_INPUT_CHANGE, value })
const onEnter = (value) => ({ type: ON_ENTER, value })
const onSkuChange = (value) => ({ type: ON_SKU_CHANGE, value })
const clearSku = () => ({ type: CLEAR_SKU })
const clearSearch = () => ({ type: CLEAR_SEARCH })
const clearTableFilter = () => ({ type: CLEAR_TABLE_FILTER })
const clearTableSort = () => ({ type: CLEAR_TABLE_SORT })
const updateSku = (value) => ({ type: UPDATE_SKU, value })
const updateSearch = (value) => ({ type: UPDATE_SEARCH, value })
const updateTableFilter = (value) => ({ type: UPDATE_TABLE_FILTER, value })
const updateTableSort = (value) => ({ type: UPDATE_TABLE_SORT, value })
const onReportDurationChange = (value) => ({ type: UPDATE_REPORT_DURATION, value })


//ProductSkus API actions i.e. main, start, success and error. Async for loader/spinner.

const fetchProductSkus = (value) => ({ type: FETCH_PRODUCT_SKUS, value })
const fetchProductSkusStart = () => ({ type: FETCH_PRODUCT_SKUS_START })
const fetchProductSkusSuccess = () => ({ type: FETCH_PRODUCT_SKUS_SUCCESS })
const fetchProductSkusError = (error) => ({ type: FETCH_PRODUCT_SKUS_ERROR, error })
const startFetchProductSkusAsync = buildAsyncAction(
  FETCH_PRODUCT_SKUS,
  FETCH_PRODUCT_SKUS_START,
  [FETCH_PRODUCT_SKUS_SUCCESS, FETCH_PRODUCT_SKUS_ERROR]
)

//WeeklyStatusReport API actions i.e. main, start, success and error. Async for loader/spinner.

const fetchWeeklyStatusReport = (sku, week, year, query) => ({ type: FETCH_WEEKLYSTATUS_REPORT, query, sku, week, year })
const fetchWeeklyStatusReportStart = () => ({ type: FETCH_WEEKLYSTATUS_REPORT_START })
const fetchWeeklyStatusReportSuccess = () => ({ type: FETCH_WEEKLYSTATUS_REPORT_SUCCESS })
const fetchWeeklyStatusReportError = (error) => ({ type: FETCH_WEEKLYSTATUS_REPORT_ERROR, error })
const startFetchWeeklyStatusReportAsync = buildAsyncAction(
  FETCH_WEEKLYSTATUS_REPORT,
  FETCH_WEEKLYSTATUS_REPORT_START,
  [FETCH_WEEKLYSTATUS_REPORT_SUCCESS, FETCH_WEEKLYSTATUS_REPORT_ERROR]
)

export {
  mount,

  onInputChange,
  onEnter,
  onSkuChange,
  clearSku,
  clearSearch,
  clearTableFilter,
  clearTableSort,
  updateSku,
  updateSearch,
  updateTableFilter,
  updateTableSort,
  onReportDurationChange,

  fetchProductSkus,
  fetchProductSkusStart,
  fetchProductSkusSuccess,
  fetchProductSkusError,
  startFetchProductSkusAsync,

  fetchWeeklyStatusReport,
  fetchWeeklyStatusReportStart,
  fetchWeeklyStatusReportSuccess,
  fetchWeeklyStatusReportError,
  startFetchWeeklyStatusReportAsync,
}